import React from 'react';

export default function() {
    return (
        <div className="not-found">
            <p>{this.l10n('NEWS_NOT_FOUND')}</p>
        </div>
    );
}
